import React from 'react'
import Drawer from './Drawer';
import {Warning} from "../../wui-core/src";

import { EntranceProps } from './iDrawer'
import DrawerFooter from './DrawerFooter';
const {isShouldUpdate} = Warning;

// 定义 DrawerWrapper 的类型，包含 Footer 属性
interface DrawerWrapperComponent extends React.FC<EntranceProps> {
    Footer: typeof DrawerFooter;
}

const DrawerWrapper: React.FC<EntranceProps> = (props) => {
    const {
        show,
        visible,
        showMask,
        mask,
        showClose,
        closable,
        getContainer,
        container,
        ...others
    } = props;

    isShouldUpdate("Drawer", props);

    const extral = {
        show: visible ? visible : show,
        showMask: mask != undefined ? mask : showMask,
        showClose: closable ? closable : showClose,
        container: getContainer ? getContainer : container
    };

    return <Drawer {...extral} {...others} />;
};

// 类型断言，确保 TypeScript 识别 Footer 属性
(DrawerWrapper as DrawerWrapperComponent).Footer = DrawerFooter;

export default DrawerWrapper as DrawerWrapperComponent;
